import { FauxTable, FauxTableRow } from "@components/FauxTable";
import { dateColumn, genericColumn, textareaColumn } from "./columnHelpers";
import { Alert, Tooltip, Typography } from "@mui/joy";
import { formatDate } from "@utils/dates";
import ObjectPreview from "@components/objects/ObjectPreview";
import { useUserIsSetupCorrectly } from "@hooks/useUserIsSetupCorrectly";

const ContactReportEditWarning = () => {
    const isSetupCorrectly = useUserIsSetupCorrectly();

    return isSetupCorrectly ? null : (
        <Alert variant="soft" color="danger" sx={{borderRadius: 0, justifyContent: 'center'}}>
            <span>
                Your user account does not have an associated contact. Contact reports will not save. <a href="https://www.maestrocm.com/support/" target="_blank">Contact Maestro Support</a>
            </span>
        </Alert>
    );
}


export const contactReportsRelationship = {
    collapsible: false,
    title: 'Contact Reports',
    tint: 'default',
    type: 'table',
    sort: ['created_at', 'desc'],
    columns: [
        genericColumn({
            label: null,
            render: {
                show: (row) => { console.log(row); return (<>
                    <Typography fontSize={'sm'}>
                        {row.note}
                    </Typography>

                    <Typography fontSize={'sm'}>
                        {'by '}
                        {row.sent_by_contact ? (<ObjectPreview to={`/contacts/${row.contact_id}`} object={row.sent_by}>{row.sent_by_contact?.name  ?? 'N/A'}</ObjectPreview>): 'N/A'}
                        {' on '}
                        <Typography fontSize={'sm'} fontStyle={'italic'}>
                        {formatDate(row.created_at)}
                        {row.created_at !== row.updated_at && (<> (edited {formatDate(row.updated_at)})</>)}
                        {/*
                        {row.created_at !== row.updated_at && (
                        <Tooltip title={`Created ${formatDate(row.created_at)}`}>
                        <Typography fontSize={'sm'}>edited {formatDate(row.updated_at)}</Typography>
                        </Tooltip>
                        )}
                        {row.created_at === row.updated_at && (<>{formatDate(row.created_at)}</>)}
                        */}
                    </Typography>
                    </Typography>
                </>)}
            }
        })
    ]
};

export const contactReportsRelationshipEdit = {
    collapsible: false,
    title: 'Contact Reports',
    warning: <ContactReportEditWarning/>,
    tint: 'default',
    type: 'table',
    columns: [
        textareaColumn({
            label: 'Notes',
            column: 'note',
            // editableAfterSave: true,
        }),
        genericColumn({
            label: 'Details',
            type: 'date',
            column: 'created_at',
            editableAfterSave: true,
            render: {
                ...dateColumn({label: 'Details', column: 'created_at'}).render,
                editDisabled: (row) => {
                    return (<>
                        <FauxTable>
                            {/*
                            <FauxTableRow
                                title={row.created_at === row.updated_at ? 'Created' : 'Updated'}
                                tooltipTitle={row.created_at !== row.updated_at && `Created ${formatDate(row.created_at)}`}
                            >
                                <Typography>{formatDate(row.updated_at)}</Typography>
                            </FauxTableRow>
                            */}
                            <FauxTableRow
                                title={'Added'}
                            >
                                <Typography>{formatDate(row.created_at)}</Typography>
                            </FauxTableRow>
                            {row.created_at !== row.updated_at && (
                            <FauxTableRow
                                title={'Edited'}
                            >
                                <Typography>{formatDate(row.updated_at)}</Typography>
                            </FauxTableRow>
                            )}
                            <FauxTableRow title={'Person'}>
                                {row.sent_by_contact?.name ?? 'N/A'}
                            </FauxTableRow>
                        </FauxTable>
                    </>);
                }
            },
        })
    ],
    newRowData: ({user}) => ({
        sent_by: user.contact.id,
        created_at: new Date(),
    }),
};
